import { useContext } from 'react';
import { AssetContext } from '../../shared/providers/AssetProvider';
import { type AssetView } from '../../types/assetView.types';

type UseAssetResult = {
  asset: AssetView;
  assets: AssetView[];
};

/**
 * UseAsset returns the asset that the user is currently viewing. The assets are passed in on init of the
 * application from outside, wrapped in AssetView instances, and provided through AssetContext.
 */
export const useAsset = (): UseAssetResult => {
  const assets = useContext(AssetContext);
  if (!assets) {
    throw new Error('useAsset must be used within an AssetProvider');
  }

  return {
    asset: assets[0],
    assets,
  };
};

export default useAsset;
